import { render, staticRenderFns } from "./EditRenewalPrice.vue?vue&type=template&id=2f0072bf&scoped=true&"
import script from "./EditRenewalPrice.vue?vue&type=script&lang=js&"
export * from "./EditRenewalPrice.vue?vue&type=script&lang=js&"
import style0 from "./EditRenewalPrice.vue?vue&type=style&index=0&id=2f0072bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0072bf",
  null
  
)

export default component.exports